import { render, staticRenderFns } from "./ServiceManagement.vue?vue&type=template&id=7ef4947a&scoped=true"
import script from "./ServiceManagement.vue?vue&type=script&lang=js"
export * from "./ServiceManagement.vue?vue&type=script&lang=js"
import style0 from "./ServiceManagement.vue?vue&type=style&index=0&id=7ef4947a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef4947a",
  null
  
)

export default component.exports